import { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../../GlobalContext'
import Card from '../../ui-elements/Card'
import ExpandCollapseIcon from '../../ui-elements/ExpandCollapseIcon'
import ChecklistReminders from './ChecklistReminders'

type Props = {
}


function RemindersPanel({

}: Props) {

    const {
        tableData,
        sendMessageToWebsocket,
        t
    } = useContext(GlobalContext)


    // const [checklistReminders, setChecklistReminders] = useState<ObjectStringKeyAnyValue | null>(null)
    const [checkPeriodsToSignoff, setCheckPeriodsToSignoff] = useState<ObjectStringKeyAnyValue | null>(null)
    const [remindersToDisplay, setRemindersToDisplay] = useState<Array<ObjectStringKeyAnyValue> | null>(null)
    const [isExpanded, setIsExpanded] = useState(true)
    const numberOfChecklistReminders = remindersToDisplay ? remindersToDisplay.length : 0
    const numberOfSignoffReminders = checkPeriodsToSignoff ? Object.keys(checkPeriodsToSignoff).length : 0
    const numberOfAlerts = numberOfChecklistReminders + numberOfSignoffReminders


    // filter and sort checklist due reminders
    useEffect(() => {
        if (tableData && tableData['Reminders']) {
            let remindersToDisplayLocal: Array<ObjectStringKeyAnyValue> = []
            for (const reminderId in tableData['Reminders']) {
                const thisReminder = tableData['Reminders'][reminderId]
                if (thisReminder['reminderStatus'] === 'due' || thisReminder['reminderStatus'] === 'overdue') {
                    remindersToDisplayLocal.push(thisReminder)
                }
            }
            remindersToDisplayLocal.sort((a, b) => parseInt(`${a.nextDueTimeStamp}`) - parseInt(`${b.nextDueTimeStamp}`))
            setRemindersToDisplay(remindersToDisplayLocal)
        }
    }, [tableData])

 
    if (numberOfAlerts === 0) {
        return <Card>
            <div className={`w-full flex flex-row items-center gap-3`}>
                <h3 className={`text-3xl`}>
                    ✅
                </h3>
                <h3 className={`text-lg font-righteous text-brandblue`}>
                    {t('Dashboard.RemindersPanel.RemindersPanel.noAlerts')}
                </h3>
            </div>
        </Card>
    }


    return <div className={`rounded px-4 py-2 border bg-red-100 border-red-400 flex flex-col w-full gap-2`}>
        <div className={`w-full flex flex-row items-center justify-between gap-2`}>
            <div className={`w-full flex flex-row items-center gap-2`}>
                <div className={`rounded-full bg-red-500 p-2 text-white text-xl font-righteous w-8 h-8 flex items-center justify-center`}>
                    {numberOfAlerts}
                </div>
                <h3 className={`text-lg font-righteous text-red-600`}>
                    {t('Dashboard.RemindersPanel.RemindersPanel.checklistsDue')}
                </h3>
            </div>
            <ExpandCollapseIcon
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
                bgcolor={`bg-white`}
                textcolor={`text-red-600`}
                size='medium'
            />
        </div>
        <ChecklistReminders
            remindersToDisplay={remindersToDisplay}
            setRemindersToDisplay={setRemindersToDisplay}
            isExpanded={isExpanded}
        />
    </div>
}
export default RemindersPanel